import React from 'react'
import imgBtn from '@assets/web-v3-images/btn-buy.png'
import { useTranslation } from 'react-i18next';

export function InputText({ label, required, placeholder, value, onChange, status, inputRef, maxLength, errorMessage, isOTP = false, handleSendOTP, countdown, inputMode, pattern, autoCapitalize }) {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col gap-2 mb-4 w-full">
			{label && (
				<div className="flex gap-1 text-[15px] sm:text-[20px] font-bold text-[rgba(161,92,7,1)]">
					<span>{label}</span>
					{required && <span className="text-[rgba(161,92,7,1)]">*</span>}
				</div>
			)}
			<div className="relative w-full">
				<input
					ref={inputRef}
					type="text"
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					maxLength={maxLength}
					inputMode={inputMode}
					pattern={pattern}
					autoCapitalize={autoCapitalize}
					className={`
          w-full h-11.5 sm:h-13 px-5 rounded-[15px] font-medium text-[15px] sm:text-[18px] outline-none
          bg-[#fdf6e9] text-[rgba(161,92,7,1)] border-[1.5px]
          placeholder:text-[rgba(161,92,7,1)]
          transition-colors
          focus:border-[#c9822f] focus:ring-[3px] focus:ring-[#c9822f]/15
          ${status === "error" ? "border-red-500" : "border-[#e8b06a]"}
        `}
				/>
				{isOTP &&
					<button
						disabled={countdown > 0}
						onClick={handleSendOTP}
						className="p-2 absolute right-4 top-1/2 -translate-y-1/2 btn-click-active disabled:opacity-50 disabled:cursor-not-allowed"
						style={{
							backgroundImage: `url(${imgBtn})`,
							backgroundSize: "100% 100%",
							backgroundRepeat: "no-repeat",
						}}
					>
						<span
							className="text-white font-black text-[14px]"
							style={{
							}}
						>
							{countdown === 0 ? t("modal.modal_login.send_OTP") : `${t("modal.modal_login.resend")} ${countdown}s`}
						</span>
					</button>
				}
			</div>
			{status === "error" && errorMessage && (
				<span className="text-[rgba(161,92,7,1)] text-[12px] sm:text-[15px] mt-1">{errorMessage}</span>
			)}
		</div>
	);
}